/**
 * @generated SignedSource<<1a591441f9173e44b2750fac7038a236>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DashboardPageQuery$variables = {};
export type DashboardPageQuery$data = {
  readonly adminCapabilities: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly adminFeatureFlags: ReadonlyArray<{
    readonly slug: string;
  }>;
  readonly admins: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      } | null;
    } | null>;
  };
  readonly restaurants: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      } | null;
    } | null>;
  };
};
export type DashboardPageQuery = {
  response: DashboardPageQuery$data;
  variables: DashboardPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": (v0/*: any*/),
    "concreteType": "RestaurantConnection",
    "kind": "LinkedField",
    "name": "restaurants",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RestaurantEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Restaurant",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": (v1/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "restaurants(first:1000)"
  },
  {
    "alias": null,
    "args": (v0/*: any*/),
    "concreteType": "AdminUserConnection",
    "kind": "LinkedField",
    "name": "admins",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminUserEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AdminUser",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": (v1/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "admins(first:1000)"
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "HardcodedFeatureFlag",
    "kind": "LinkedField",
    "name": "adminFeatureFlags",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Capability",
    "kind": "LinkedField",
    "name": "adminCapabilities",
    "plural": true,
    "selections": (v1/*: any*/),
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardPageQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DashboardPageQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "f0372e5fe88ea31d8a0bfbd84c00949b",
    "id": null,
    "metadata": {},
    "name": "DashboardPageQuery",
    "operationKind": "query",
    "text": "query DashboardPageQuery {\n  restaurants(first: 1000) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  admins(first: 1000) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  adminFeatureFlags {\n    slug\n  }\n  adminCapabilities {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4867e721f87a4c8ffbac2e47e4a9c53e";

export default node;
